import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from './components/components.module';
import { SchedulingScenarioService } from './scheduling-scenario.service';
import { RecordAppointmentDepositService } from './components/appointment-view-sidebar/record-appointment-deposit.service';

@NgModule({
  imports: [CommonModule, ComponentsModule],
  exports: [ComponentsModule],
  providers: [
    SchedulingScenarioService,
    RecordAppointmentDepositService,
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
  ],
})
export class NgAppointmentModule {}
